'use strict';

/**
 * AdminController - contrôleur principal du panneau d'administration
 */
import appModule from '../app.module';

angular.module(appModule)
.controller('AdminController', ['$scope', '$state', 'Auth', function($scope, $state, Auth) {
  
  // Vérifier si l'utilisateur a les autorisations administratives
  Auth.identity().then(function(user) {
    if (!user || !Auth.hasAnyAuthority(['ROLE_ADMIN', 'ROLE_MODERATOR', 'ROLE_EDITOR'])) {
      $state.go('login');
      return;
    }
    
    $scope.user = user;
  });
  
  // Menu de navigation du panneau d'administration
  $scope.adminMenu = [
    { title: 'Tableau de bord', state: 'admin.dashboard', icon: 'dashboard', roles: ['ROLE_ADMIN', 'ROLE_MODERATOR', 'ROLE_EDITOR'] },
    { title: 'Jeux de données', state: 'admin.datasets', icon: 'dataset', roles: ['ROLE_ADMIN', 'ROLE_EDITOR'] },
    { title: 'Organisations', state: 'admin.organizations', icon: 'business', roles: ['ROLE_ADMIN', 'ROLE_EDITOR'] },
    { title: 'Utilisateurs', state: 'admin.users', icon: 'people', roles: ['ROLE_ADMIN'] }
  ];
  
  // Filtrer les éléments du menu en fonction des autorisations
  $scope.canAccess = function(menuItem) {
    return Auth.hasAnyAuthority(menuItem.roles);
  };
}]);
